<template>
    <div class="table-tools-actions flex justify-center md:justify-end w-full items-center space-x-2 select-none pr-4">
      <!-- <base-button @click="applyFilters" size="xs" class="w-full md:w-auto" text="Refrescar"></base-button> -->
      <el-tooltip 
        v-model="tooltipVisible"
        :manual="true"
        :tabindex="-1"
        :open-delay="750" 
        placement="left"
        >
        <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''"
            @mouseenter="tooltipVisible = true"
            @mouseleave="tooltipVisible = false">                    
          <div class="max-w-sm max-h-500p overflow-auto ">                  
            Refrescar la vista
          </div>
        </div>
        <div>
          <base-button 
            icon="reload" 
            text=" " 
            @click="applyFilters" 
            size="xs-button" 
            class="w-full md:w-auto" 
            ariaLabel="Refrescar la vista"
            @keydown.esc="tooltipVisible = false"
            @mouseenter="tooltipVisible = true"
            @mouseleave="tooltipVisible = false"
            @focus="tooltipVisible = true"
            @blur="tooltipVisible = false"
            />
        </div>
      </el-tooltip>
    </div>
</template>

<script>
export default {
  name: 'base-table-reload',
  data: function () {
    return {
      search: '',
      tooltipVisible: false,
    }
  },
  watch: {
    tooltipVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydown)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  methods: {
    applyFilters: function () {
      // this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
      this.$emit('applyFilters')
    },
    onKeydown (event) {
      if (event.key === 'Escape') {
        this.tooltipVisible = false
      }
    }
  },
}
</script>

